import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HomePage, CategoryPage, AdminPage, AboutPage } from './pages';
import Navbar from './layout/Navbar';
import NewsDetailPage from './components/NewsDetailPage';
import Footer from './components/Footer';
import ProtectedRoute from "./protectedRoutes.js";
import Login from "./login/Login.jsx";
const App = () => {

  return (
    <BrowserRouter>
      <Navbar />
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow mt-10">
          <>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/:category" element={<CategoryPage />} />
              <Route path="/news/:idAndSlug" element={<NewsDetailPage />} />
              <Route path="/admin" element={<ProtectedRoute element={<AdminPage />} isAdmin={true} />} />
              {/* <Route path="/admin" element={<AdminPage />} /> */}
              <Route path="/about" element={<AboutPage />} />
              <Route path="/login" element={<Login />} />
            </Routes>
          </>
        </main>
        {/* <Footer /> */}
      </div>
    </BrowserRouter>
  );
};

export default App;